import { FC } from 'react'
import styled from 'styled-components'

interface IFTitleProps {
  className?: string
}

const Title: FC<IFTitleProps> = ({ className }) => {
  return <StyledWrapper className={className}>모집직무</StyledWrapper>
}

export default Title

const StyledWrapper = styled.div`
  font-size: 14px;
  font-weight: bold;
`
